/**
 * Session Management Helper
 * Maneja la sesión del cliente usando localStorage
 * Key: "fv_session"
 */

const SESSION_KEY = 'fv_session';

/**
 * Obtiene el token de sesión actual
 * @returns Token de sesión o null si no existe
 */
export function getSession(): string | null {
  try {
    return localStorage.getItem(SESSION_KEY);
  } catch (error) {
    console.error('Error al leer sesión:', error);
    return null;
  }
}

/**
 * Guarda el token de sesión
 * @param token Token de sesión a guardar
 */
export function setSession(token: string): void {
  try {
    localStorage.setItem(SESSION_KEY, token);
  } catch (error) {
    console.error('Error al guardar sesión:', error);
  }
}

/**
 * Limpia la sesión actual
 */
export function clearSession(): void {
  try {
    localStorage.removeItem(SESSION_KEY);
  } catch (error) {
    console.error('Error al limpiar sesión:', error);
  }
}

/**
 * Verifica si existe una sesión activa
 * @returns true si existe sesión, false en caso contrario
 */
export function hasSession(): boolean {
  return getSession() !== null;
}
